export const ukPostalCode = /^[A-Z]{1,2}[0-9]{1,2}[A-Z]{0,1} ?[0-9][A-Z]{2}$/;
export const onlyDigits = /^[0-9]+$/;
export const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*].{12,}$/;
export const onlyLetters = /^[a-zA-Z\s]*$/;
export const namesPattern = /^[^\d@_!#$%^&*()<>?}{~:;`]*$/;
export const adviserFCA = /^[a-zA-Z]{3}\d{5}$/;
export const alphaNumeric = /^[a-z0-9\s]+$/im;
export const estateAgent = /^[a-z0-9\s]+|^[-+]?[0-9]*\.?[0-9]+$/i;
export const sortCode = /^[0-9]{6}$/;
export const dateOfBirth = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;
